/* Emerald — Mango back-in-stock waitlist
 * Supergreens "Mango" is out of stock (back W/C 15 June). The buy box renders a
 * disabled "Mango (Coming Soon)" flavour pill. This makes that pill open an email
 * capture that subscribes the shopper to the Klaviyo "Mango Ignite Waitlist" list
 * (ID VRcAjT) via Klaviyo's onsite client API — which feeds the existing
 * "Waitlist Nurture" flow. On restock, send a "Mango is back" campaign to that list.
 *
 * Self-gates to the Supergreens PDP. Loaded from product-media-gallery.liquid.
 * REMOVE / no-op once Mango is restocked (or just leave — the pill reverts to a
 * normal flavour selector when Mango is back in stock and the buy box re-renders it).
 */
(function () {
  if (window.__emWaitlist) return; window.__emWaitlist = true;
  if (location.pathname.indexOf('/products/emerald-nutrition-supergreens') === -1) return;

  var COMPANY = 'TJWES2';   // Klaviyo public site ID
  var LIST = 'VRcAjT';      // "Mango Ignite Waitlist"
  var BACK = 'week commencing 15 June';

  function init() {
    var pill = document.querySelector('.empz-fl.sold-out');
    if (!pill) return false;
    if (pill.dataset.wlWired) return true;
    pill.dataset.wlWired = '1';
    pill.removeAttribute('disabled');
    pill.style.cursor = 'pointer';
    pill.setAttribute('aria-haspopup', 'true');
    pill.addEventListener('click', toggleForm);
    return true;
  }

  function toggleForm(e) {
    if (e) e.preventDefault();
    var existing = document.getElementById('emz-wl');
    if (existing) { existing.style.display = existing.style.display === 'none' ? '' : 'none'; return; }
    var pills = document.querySelector('.empz-flavours');
    if (!pills) return;
    var box = document.createElement('div');
    box.id = 'emz-wl';
    box.style.cssText = 'margin:-12px 0 22px;padding:14px;border:1px solid #E4DFD8;border-radius:12px;background:#FAF8F4;font-family:\'Inter\',sans-serif;';
    box.innerHTML =
      '<div style="font-size:13px;font-weight:700;color:#1A1A1A;margin-bottom:4px;">Mango is back ' + BACK + '</div>' +
      '<div style="font-size:12px;color:#666;margin-bottom:10px;">Pop your email in and we’ll tell you the moment it lands.</div>' +
      '<div style="display:flex;gap:8px;"><input id="emz-wl-email" type="email" autocomplete="email" placeholder="you@email.com" style="flex:1;min-width:0;padding:10px 12px;border:1px solid #ccc;border-radius:8px;font-size:14px;font-family:inherit;">' +
      '<button id="emz-wl-btn" type="button" style="background:#0C5235;color:#fff;border:none;border-radius:8px;padding:10px 16px;font-size:14px;font-weight:700;cursor:pointer;white-space:nowrap;font-family:inherit;">Notify me</button></div>' +
      '<div id="emz-wl-msg" style="font-size:12px;margin-top:8px;display:none;"></div>';
    pills.insertAdjacentElement('afterend', box);
    document.getElementById('emz-wl-btn').addEventListener('click', submit);
    var inp = document.getElementById('emz-wl-email');
    inp.addEventListener('keydown', function (ev) { if (ev.key === 'Enter') submit(); });
    inp.focus();
  }

  function show(el, t, c) { if (!el) return; el.textContent = t; el.style.color = c; el.style.display = ''; }

  function submit() {
    var inp = document.getElementById('emz-wl-email');
    var msg = document.getElementById('emz-wl-msg');
    var btn = document.getElementById('emz-wl-btn');
    var email = (inp && inp.value || '').trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { show(msg, 'Please enter a valid email address.', '#C00'); return; }
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: email, properties: { 'Waitlist Product': 'Supergreens Mango' } } } }
          },
          relationships: { list: { data: { type: 'list', id: LIST } } }
        }
      })
    }).then(function (r) {
      if (r.ok || r.status === 202) {
        show(msg, 'You’re on the list — we’ll email you when Mango’s back.', '#0C5235');
        if (inp) inp.style.display = 'none';
        if (btn) btn.style.display = 'none';
      } else {
        show(msg, 'Something went wrong — please try again.', '#C00');
        if (btn) { btn.disabled = false; btn.textContent = 'Notify me'; }
      }
    }).catch(function () {
      show(msg, 'Something went wrong — please try again.', '#C00');
      if (btn) { btn.disabled = false; btn.textContent = 'Notify me'; }
    });
  }

  function boot() {
    if (init()) return;
    var n = 0, iv = setInterval(function () { if (init() || ++n > 40) clearInterval(iv); }, 250);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
